<div class="card">
    <div class="card-header">
        {{pageTitle}}
    </div>
    <div class="card-body">
        <div class="row">
            <div class="col-md-2">Filter by:</div>
            <div class="col-md-4">
                <input type="text" [(ngModel)]='listFilter'/>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <h4>Filtered by:{{listFilter}}</h4>
            </div>
        </div>
        <div class="table-responsive">
            <table class="table" *ngIf="products && products.length>0">
                <thead>
                <tr>
                    <th>
                        <button class="btn btn-primary" (click)="toggleImage()">
                           {{showImage?'Hide':'Show'}} image
                        </button>
                    </th>
                    <th>Producto</th>
                    <th>Codigo</th>
                    <th>Descripción</th>
                    <th>Tipo</th>
                    <th>Precio</th>
                    <th>Rating</th>
                </tr>
                </thead>
                <tbody>
                    <tr *ngFor='let product of filteredProducts'>
                        <td>
                            <img *ngIf="showImage"
                                 [src]="product.images[0].fileName"
                                 [title]="product.images[0].caption"
                                 [style.width.px]="imageWidth"
                                 [style.marging.px]="imageMargin" />
                        </td>
                        <td><a [routerLink]="['/products',product.productId]">{{product.title}}</a></td>
                        <td>{{product.productId | lowercase | convertToSpaces:'-'}}</td>
                        <td>{{product.description}}</td>
                        <td>{{product.productType.title}}</td>
                        <td>${{product.price}}</td>
                        <td><pm-star [rating]="product.starRating"
                                     (ratingClicked)="onRatingClicked($event)"></pm-star></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>